import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import styles from "./languageSelect.style";

const LanguageSelect = props => {
    const { classes, languages, selectedLanguage } = props;
    return (
        <FormControl data-testid="language_picker">
            <Select
                labelid="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedLanguage || ""}
                onChange={e => props.onChange(e.target.value)}
                disableUnderline
                IconComponent={() => null}
                classes={{
                    root: classes.selectControl,
                    select: classes.menuSelect
                }}
            >
                {languages &&
                    languages.length > 0 &&
                    languages.map(options => {
                        const { code, name } = options;
                        return (
                            <MenuItem value={code} key={code} data-testid="language">
                                {name}
                            </MenuItem>
                        );
                    })}
                {(!languages || languages.length === 0) && (
                    <MenuItem value="en" key="en">
                        English
                    </MenuItem>
                )}
            </Select>
        </FormControl>
    );
};

LanguageSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    languages: PropTypes.array || undefined,
    selectedLanguage: PropTypes.string || undefined
};

export default withStyles(styles)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/components/StartContainer/LanguageSelect/LanguageSelect.js